import React from 'react';
import './Loading.css';

const Loading: React.FC = () => {
    return (
        <div className="loading-page">
            <div className="loading-glow" />
            <img
                src="/images/loading-page-logo.svg"
                alt="Spec"
                className="loading-logo"
            />
        </div>
    );
};

export default Loading;
